<template id="section-order">
  <div class="section-orders">
		<p class="title-orders">APP DE PEDIDOS</p>
		<p class="subtitle-orders mb-5">TUS DISTRIBUIDORES, TUS ALIADOS CON  <span class="text-green">MIBODEGA</span></p>
		<div class="content-orders">
			<div class="w-50">
				<img src="/static/img/ipad.png" alt="tablet" width="100%">
			</div>
			<div class="item-orders w-50">
				<div class="items" v-for="(item, index) in items" :key="index">
					<p class="name-item mb-0">{{ item.name }}</p>
					<p class="description-item mb-0">{{ item.subtitle }}</p>
				</div>
			</div>
			</div>
		<div class="content-btn">
			<a href="#footer">
				<button class="btn-information">SOLICITA MÁS INFORMACIÓN</button>
			</a>
		</div>
	</div>
</template>

<script>
export default {
	name: 'section-orders',
	props: {
		items: {
			type: Array,
			default: () => [],
		},
	},
};
</script>

<style lang="scss" scoped>
.title-orders {
	font-family: font(lato-regular);
	font-weight: 600;
	color: #4a4a4a;
	font-size: 32px;
	text-align: center;

	@media (max-width: 936px) {
		font-size: 20px;
	}
}

.section-orders {
	background: map-get($colors, back-gray);
	padding: 18px 7%;
}

.subtitle-orders {
	color: map-get($colors, title);
	font-family: font(lato-regular);
	font-size: map-get($sizes, large);
	text-align: center;

	@media (max-width: 936px) {
		font-size: 20px;
	}
}

.text-green {
	color: map-get($colors, title-green);
	font-family: font(lato-regular);
}

.btn-information {
	background-color: #b2dd00;
	border-radius: 19.5px;
	color: white;
	font-family: font(lato-regular);
	font-weight: 600;
	font-size: 14px;
	height: 39px;
	width: 332px;
}

.name-item {
	color: #02979b;
	font-family: font(lato-regular);
	font-weight: 600;
	font-size: 17px;
	text-align: center;
}

.description-item {
	color: #4a4a4a;
	font-family: font(lato-regular);
	font-size: 16px;
	margin: 0 auto;
	text-align: center;
	width: 300px;
}

.content-orders {
	align-items: center;
	display: flex;
	justify-content: center;
	flex-wrap: wrap;
}

.item-orders {
	display: flex;
	flex-direction: column;

	@media (max-width: 936px) {
		margin-top: 25px;
	}
}

.content-btn {
	display: flex;
	justify-content: center;
	margin-top: 28px;
}

.items {
	margin-bottom: 29px;
}

.w-50 {
	width: 50%;

	@media (max-width: 936px) {
		width: 100%;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/home/section-orders.vue